import { render, staticRenderFns } from "./EditDetails.vue?vue&type=template&id=092f36e8&scoped=true"
import script from "./EditDetails.vue?vue&type=script&lang=js"
export * from "./EditDetails.vue?vue&type=script&lang=js"
import style0 from "./EditDetails.vue?vue&type=style&index=0&id=092f36e8&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "092f36e8",
  null
  
)

export default component.exports